export const iconFontAwesomeFoodBeverageBacon = (
	<i className="fa-solid fa-bacon"></i>
);
